import { styled } from '@mui/material';

export const ConfiguratorAssetImage = styled('img')(() => ({
  width: '280px'
}));
